export enum RentalDocumentTypeEnum {
  CountyRegistration = 'CountyRegistration',
  ProofOfInsurance = 'ProofOfInsurance',
  Additional = 'Additional',
}

export const rentalDocumentTypeMap: Record<RentalDocumentTypeEnum, string> = {
  [RentalDocumentTypeEnum.CountyRegistration]: 'County Registration',
  [RentalDocumentTypeEnum.ProofOfInsurance]: 'Proof of Insurance',
  [RentalDocumentTypeEnum.Additional]: 'Additional Document',
};
